import capitalize from '../capitalize'
import getTextCase from '../getTextCase'

function getReplacement(match, config) {
  return getTextCase(match) === 'upper'
    ? config.split(/\b/).reduce((phrase, word) => `${phrase}${capitalize(word)}`, '')
    : config.toLowerCase()
}

export default function performOntologyReplacements(translatedString, ontology) {
  const replacementRules = [
    {
      regex: ontology.regexPluralPossessive,
      config: ontology.configPluralPossessive,
    },
    {
      regex: ontology.regexPlural,
      config: ontology.configPlural,
    },
    {
      regex: ontology.regexSingularPossessive,
      config: ontology.configSingularPossessive,
    },
    {
      regex: ontology.regexSingular,
      config: ontology.configSingular,
    },
  ]

  return translatedString.split(/\b/).reduce((phrase, word) => {
    for (const rule of replacementRules) {
      if (rule.regex.test(word)) {
        const match = word.match(rule.regex)[0]
        const config = rule.config
        const replacement = getReplacement(match, config)
        return `${phrase}${replacement}`
      }
    }
    return `${phrase}${word}`
  }, '')
}
